module.exports = __webpack_public_path__ + "img/login.8d019e51.png";